import React from 'react';
import { Tag } from 'antd';
import { Lineitem } from '../../../interfaces/Ordel.Interface';
import { InspectionSampleLabelingTag } from '../../InspectionSampleLabeling';
import {
	QUEUE_CLASS_LABELS,
	isKittingQueueClass,
	kittingChips,
} from './kittingClassification';

interface Props {
	item: Lineitem;
}

const QueueClassTags: React.FC<Props> = ({ item }) => {
	const queueClass = isKittingQueueClass(item.queue_class)
		? item.queue_class
		: null;
	const chips = kittingChips(item);
	if (!queueClass && chips.length === 0 && !item.requires_inspection_sample_labeling) {
		return null;
	}
	const classLabel = queueClass ? QUEUE_CLASS_LABELS[queueClass] : null;

	return (
		<div className="flex flex-wrap items-center gap-1">
			{classLabel && (
				<Tag
					data-testid="fastlane-kit-queue-class"
					color={classLabel.color}
					style={{ fontSize: 15, marginInlineEnd: 0 }}
				>
					{classLabel.label}
				</Tag>
			)}
			{chips.map((chip) => (
				<Tag
					key={chip.label}
					data-testid="fastlane-kit-chip"
					color={chip.color}
					style={{ fontSize: 13, marginInlineEnd: 0 }}
				>
					{chip.label}
				</Tag>
			))}
			{item.requires_inspection_sample_labeling && (
				<InspectionSampleLabelingTag />
			)}
		</div>
	);
};

export default QueueClassTags;
